<template>
  <div class="sales dashboard">
    <div class="actions flex flex-col md:flex-row justify-between">
      <div class="action-left mb-2 md:mb-0 md:mr-4">
        <h2 class="text-xl md:text-left">Dashboard</h2>
      </div>

      <div class="search flex items-center md:ml-4">
        <button class="btn btn-main" @click="handleNewEntry">New Entry</button>
        <input
          type="text"
          placeholder="Search"
          v-model="search"
          class="input-search ml-2"
          @keyup="handleSearchChange"
        />
      </div>
    </div>

    <SalesEditor
      v-if="showEditor"
      :editId="editId"
      :editData="editData"
      @overlayClick="handleOverlayClick"
      @recordCreated="handleRecordCreated"
      @recordUpdated="closeOverlay"
      @recordDeleted="closeOverlay"
    ></SalesEditor>
    <div class="grid-wrap" style="height: calc(100vh - 172px)">
      <ag-grid-vue
        style="width: 100%; height: 100%"
        class="ag-theme-alpine ag-theme-capitol"
        :getRowId="(params) => params.data.id"
        :columnDefs="columnDefs"
        :rowData="sales"
        :defaultColDef="defaultColDef"
        :getContextMenuItems="getContextMenuItems"
        :suppressColumnMoveAnimation="true"
        :statusBar="{
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left',
            },
          ],
        }"
        @grid-ready="onGridReady"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import "../../lib/ag-grid-enterprise";
import { AgGridVue } from "ag-grid-vue";
import { db } from "../database/db.js";
import SalesEditor from "@/components/SalesEditor.vue";
import { dateColumn } from "@/utils/columns";

const defaultColDef = {
  flex: 1,
  editable: false,
  sortable: true,
  resizable: true,
  wrapText: true,
  wrapHeaderText: true,
  width: 140,
  enableCellChangeFlash: true,
};

export default {
  data() {
    return {
      search: "",
      sales: [],
      columnDefs: null,
      defaultColDef,
      gridApi: null,
      columnApi: null,
      showEditor: false,
      editId: null,
      editData: null,
    };
  },
  // firestore: {
  //   sales: db.collection("sales").orderBy("created", "desc"),
  // },
  components: {
    AgGridVue,
    SalesEditor,
  },
  created() {
    let time1 = new Date();
    time1.setHours(0);
    let time2 = new Date();
    time2.setHours(23, 59);
    this.$bind(
      "sales",
      db
        .collection("sales")
        .where("sales_date", ">", time1)
        .where("sales_date", "<", time2)
    )
      .then((sales) => {
        this.sales = sales;
      })
      .catch((e) => {
        if (e.message.includes("insufficient permissions")) {
          this.$toasted.show("Insufficient Permissions", {
            type: "error",
            theme: "bubble",
            position: "bottom-center",
            duration: 3000,
          });
        }
      });
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      this.gridColumnApi.applyColumnState({
        state: [{ colId: "sales_date", sort: "desc" }],
        defaultState: { sort: null },
      });
      setTimeout(() => {
        params.api.sizeColumnsToFit();
      }, 50);
    },
    handleNewEntry() {
      this.editId = null;
      this.editData = null;
      this.showEditor = true;
    },
    handleOverlayClick() {
      this.showEditor = false;
    },
    handleRecordCreated(id) {
      this.showEditor = false;
      var rowNode1 = this.gridApi.getRowNode(id);
      this.gridApi.flashCells({
        rowNodes: [rowNode1],
      });
      this.gridApi.sizeColumnsToFit();
    },
    closeOverlay() {
      this.showEditor = false;
    },
    handleSearchChange(e) {
      this.gridApi.setQuickFilter(this.search);
    },
    getContextMenuItems(params) {
      var result = [
        {
          name: "Edit Record",
          action: () => {
            this.showEditor = true;
            this.editId = params.node.id;
            this.editData = params.node.data;
          },
        },
        {
          name: "Clone Record",
          action: () => {
            this.showEditor = true;
            this.editId = null;
            this.editData = params.node.data;
          },
        },
      ];
      return result;
    },
  },
  beforeMount() {
    this.columnDefs = [
      dateColumn("sales_date", "Sales Date"),
      { field: "load_num", headerName: "Load Number", minWidth: 80 },
      { field: "type", width: 120, minWidth: 120 },
      { field: "num_of_head", headerName: "Number of Head", minWidth: 80 },
      { field: "customer", minWidth: 80 },
      { field: "destination", autoHeight: true, minWidth: 80 },
      { field: "truck_num", headerName: "Truck Number", minWidth: 80 },
      { field: "pen_num", headerName: "Pen Number", minWidth: 80 },
      {
        field: "scale_weight",
        headerName: "Scale Weight",
        width: 140,
        minWidth: 140,
      },
      { field: "lot_num", headerName: "Lot Number", minWidth: 80 },
      { field: "pasture", minWidth: 80 },
      {
        field: "time_of_delivery",
        headerName: "Time Of Delivery",
        autoHeight: true,
        minWidth: 80,
      },
      { field: "invoice", minWidth: 80 },
      { field: "remarks", autoHeight: true, minWidth: 80 },
      {
        field: "off_truck_weight",
        headerName: "Off Truck Wt",
        width: 120,
        minWidth: 120,
      },
      { field: "time_unloaded", headerName: "Time Unloaded", minWidth: 80 },
      { field: "time_loaded", headerName: "Time Loaded", minWidth: 80 },
      { field: "salesman", minWidth: 80 },
      { field: "freight", minWidth: 80 },
      { field: "rate", width: 80 },
      { field: "miles", width: 80 },
      { field: "bill_of_lading", headerName: "Bill of Lading", minWidth: 80 },
    ];
  },
};
</script>

<style lang="scss">
@import "../assets/styles/main.scss";
</style>
